import PrivacyWebScreen from './privacy.web';

export default PrivacyWebScreen;
